import type { ConfluenceLinkState } from '@atlassian/jira-servicedesk-knowledge-services/src/types.tsx';

export const SET_KB_HUB = 'state.actions.set-knowledge-hub.SET_KB_HUB' as const;

export type SetKbHubPayload = ConfluenceLinkState;

export type SetKbHubAction = {
	type: typeof SET_KB_HUB;
	payload: SetKbHubPayload;
};

export const setKbHub = (payload: SetKbHubPayload): SetKbHubAction => ({
	type: SET_KB_HUB,
	payload,
});
